<script setup lang="ts">
import { computed } from 'vue'
import { useTranslation } from 'i18next-vue'
import { useAuthStore } from '@/stores/auth.store'
import { useMenuItems } from '@/components/navbar/useMenuItems'
import Button from 'primevue/button'
import NotificationBell from '@/components/navbar/NotificationBell.vue'

const { t } = useTranslation()
const auth = useAuthStore()

const { isRegistrationRoute, isOrganizerRoute } = useMenuItems()

const authEntryRoute = computed(() =>
    isOrganizerRoute.value ? { name: 'organizer' } : { name: 'register-participant' }
)

const crossLink = computed(() => {
    if (isRegistrationRoute.value) return null
    if (isOrganizerRoute.value) {
        return {
            label: t('ui.navigation.explore'),
            to: { name: 'explore' },
            testid: 'nav-explore-link',
        }
    }
    return {
        label: t('ui.navigation.landing-organizer'),
        to: { name: 'organizer-landing-page' },
        testid: 'nav-bar-organizer-link',
    }
})
</script>

<template>
    <!-- NOTE: This is just commented out for the MVP. It will be used later on, keep it here. This is on purpose -->
    <!-- <a -->
    <!--     class="cursor-pointer px-4 py-2 font-semibold rounded-lg hover:bg-primary-100 focus-visible:bg-primary-100" -->
    <!--     href="#" -->
    <!-- > -->
    <!--     {{ t('ui.navigation.easy-language') }} -->
    <!-- </a> -->
    <div class="flex items-center gap-4">
        <template v-if="auth.user">
            <NotificationBell />
            <span class="hidden md:block font-semibold">
                {{ t('frontend.navbar.greeting', { username: auth.user.username }) }}
            </span>
            <Button
                :label="t('ui.profile.logout')"
                text
                data-testid="nav-bar-logout-button"
                size="small"
                @click="auth.logoutUser"
            />
        </template>
        <template v-else>
            <Button
                v-if="crossLink"
                :label="crossLink.label"
                :data-testid="crossLink.testid"
                :to="crossLink.to"
                class="hidden sm:flex text-color font-semibold hover:bg-primary-100 focus-visible:bg-primary-100"
                text
                as="router-link"
                icon="pi pi-arrow-up-right"
                icon-pos="right"
            />
            <Button
                v-if="!isRegistrationRoute"
                as="router-link"
                :to="authEntryRoute"
                :label="t('ui.navigation.login')"
                data-testid="nav-bar-organizer-entry-link"
            />
        </template>
    </div>
</template>
